/**
 * Stylux Luxury Fashion - Admin Dashboard Engine
 * ----------------------------------------------------
 * High-performance administrative engine managing:
 * 1. Seeded luxury inventory database with stock counts & price adjustments
 * 2. Real-time front-end synchronization (stock badges, price updates, out-of-stock disabling)
 * 3. Order fulfillment status updates (Processing, Shipped, Delivered)
 * 4. Executive KPI calculations (Gross Sales, Orders Processed, Low Stock Alerts)
 * 5. Strict authentication & route-guard security
 */

(function () {
  'use strict';

  const INVENTORY_STORAGE_KEY = 'stylux_inventory_database';

  // --- 1. REAL STORE INVENTORY (30 Live Horology Products) ---
  const INITIAL_INVENTORY = [
    {
      id: "prod_10418082349370",
      shopifyId: 10418082349370,
      title: "Aerofusion Chrono — Black Grey Skeleton",
      handle: "aerofusion-chrono-black-grey-skeleton",
      brand: "Hublot",
      sku: "STX-9370",
      price: 2599,
      comparePrice: 4999,
      stock: 6,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/0618E0F5-8AAA-4F6D-B32D-8D54528C1C43.png?v=1788281974"
    },
    {
      id: "prod_10418080088378",
      shopifyId: 10418080088378,
      title: "Submariner — Black & Steel",
      handle: "submariner-black-steel",
      brand: "Rolex",
      sku: "STX-8378",
      price: 3000,
      comparePrice: 4999,
      stock: 8,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/688B10DC-5836-4A34-832D-A07BA5832B26.png?v=1788281974"
    },
    {
      id: "prod_10418079072570",
      shopifyId: 10418079072570,
      title: "Datejust — Ruby Red & Gold",
      handle: "datejust-ruby-red-gold",
      brand: "Rolex",
      sku: "STX-2570",
      price: 3850,
      comparePrice: 4999,
      stock: 4,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/2F590E7E-38AC-490F-BF13-9BBC26540A4A.png?v=1788281974"
    },
    {
      id: "prod_10418077073722",
      shopifyId: 10418077073722,
      title: "Diamond Blue — Deep Blue & Steel",
      handle: "diamond-blue-deep-blue-steel",
      brand: "Diamond Blue",
      sku: "STX-3722",
      price: 4199,
      comparePrice: 4999,
      stock: 5,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/65DA2DD6-570A-41E8-BC16-19C7FF1CFE84.png?v=1788281974"
    },
    {
      id: "prod_10418076483898",
      shopifyId: 10418076483898,
      title: "Textured PRX — Deep Blue & Steel",
      handle: "textured-prx-deep-blue-steel",
      brand: "Tissot",
      sku: "STX-3898",
      price: 3850,
      comparePrice: 4999,
      stock: 7,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/26022B3C-8136-43A8-BDCF-FA028F00840C.png?v=1788281974"
    },
    {
      id: "prod_10418073370938",
      shopifyId: 10418073370938,
      title: "Textured PRX — Black Tissot & Steel",
      handle: "textured-prx-black-tissot-steel",
      brand: "Tissot",
      sku: "STX-0938",
      price: 3850,
      comparePrice: 4999,
      stock: 4,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/9F86244D-48D0-489A-AA58-F491470172EF.png?v=1788281568"
    },
    {
      id: "prod_10410276356410",
      shopifyId: 10410276356410,
      title: "Nautilus — Olive Green & Leather",
      handle: "patek-nautilus-olive-green",
      brand: "Patek Philippe",
      sku: "patek-nautilus-olive-green",
      price: 3699,
      comparePrice: 4999,
      stock: 5,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/27_patek-nautilus-olive-green_front.png?v=1787641376"
    },
    {
      id: "prod_10410276290874",
      shopifyId: 10410276290874,
      title: "Nautilus — Tiffany Blue & Steel",
      handle: "patek-nautilus-tiffany",
      brand: "Patek Philippe",
      sku: "patek-nautilus-tiffany",
      price: 3649,
      comparePrice: 4999,
      stock: 2,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/26_patek-nautilus-tiffany_front.png?v=1787641376"
    },
    {
      id: "prod_10410276258106",
      shopifyId: 10410276258106,
      title: "Nautilus — Stealth Blackout Edition",
      handle: "patek-nautilus-stealth-black",
      brand: "Patek Philippe",
      sku: "patek-nautilus-stealth-black",
      price: 3699,
      comparePrice: 4999,
      stock: 6,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/25_patek-nautilus-stealth-black_front.png?v=1787641376"
    },
    {
      id: "prod_10410276192570",
      shopifyId: 10410276192570,
      title: "Nautilus — Two-Tone Gold & Leather",
      handle: "patek-nautilus-gold-leather",
      brand: "Patek Philippe",
      sku: "patek-nautilus-gold-leather",
      price: 3699,
      comparePrice: 4999,
      stock: 4,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/24_patek-nautilus-gold-leather_front.png?v=1787641376"
    },
    {
      id: "prod_10410276127034",
      shopifyId: 10410276127034,
      title: "Aerofusion Chrono — Olive Green Skeleton",
      handle: "hublot-classic-fusion-skeleton",
      brand: "Hublot",
      sku: "hublot-classic-fusion-skeleton",
      price: 2499,
      comparePrice: 4999,
      stock: 3,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/23_hublot-classic-fusion-skeleton_front.png?v=1787641375"
    },
    {
      id: "prod_10410276061498",
      shopifyId: 10410276061498,
      title: "Classic Fusion Orlinski — Emerald Green",
      handle: "hublot-orlinski-green",
      brand: "Hublot",
      sku: "hublot-orlinski-green",
      price: 3749,
      comparePrice: 4999,
      stock: 5,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/22_hublot-orlinski-green_front.png?v=1787641375"
    },
    {
      id: "prod_10410275995962",
      shopifyId: 10410275995962,
      title: "Classic Fusion Orlinski — Silver",
      handle: "hublot-orlinski-silver",
      brand: "Hublot",
      sku: "hublot-orlinski-silver",
      price: 3749,
      comparePrice: 4999,
      stock: 9,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/21_hublot-orlinski-silver_front.png?v=1787641375"
    },
    {
      id: "prod_10410275963194",
      shopifyId: 10410275963194,
      title: "PRX — Royal Blue & Steel",
      handle: "tissot-prx-blue",
      brand: "Tissot",
      sku: "tissot-prx-blue",
      price: 3699,
      comparePrice: 4999,
      stock: 8,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/20_tissot-prx-blue_front.png?v=1787641375"
    },
    {
      id: "prod_10410275897658",
      shopifyId: 10410275897658,
      title: "PRX — Emerald Green & Steel",
      handle: "tissot-prx-green",
      brand: "Tissot",
      sku: "tissot-prx-green",
      price: 3699,
      comparePrice: 4999,
      stock: 3,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/19_tissot-prx-green_front.png?v=1787641374"
    },
    {
      id: "prod_10410275832122",
      shopifyId: 10410275832122,
      title: "Datejust — Crimson Red & Steel",
      handle: "rolex-datejust-cherry",
      brand: "Rolex",
      sku: "rolex-datejust-cherry",
      price: 3850,
      comparePrice: 4999,
      stock: 7,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/18_rolex-datejust-cherry_front.png?v=1787641374"
    },
    {
      id: "prod_10410275766586",
      shopifyId: 10410275766586,
      title: "Day-Date 40mm — Arabic Dial Blue Fluted",
      handle: "rolex-day-date-gold",
      brand: "Rolex",
      sku: "rolex-day-date-gold",
      price: 3850,
      comparePrice: 4999,
      stock: 6,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/17_rolex-day-date-gold_front.png?v=1787641374"
    },
    {
      id: "prod_10410275701050",
      shopifyId: 10410275701050,
      title: "Royal Oak Two-Tone — White Tapisserie",
      handle: "diamondblue-royaloak-white",
      brand: "Audemars Piguet",
      sku: "diamondblue-royaloak-white",
      price: 3850,
      comparePrice: 4999,
      stock: 4,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/16_diamondblue-royaloak-white_front.png?v=1787641374"
    },
    {
      id: "prod_10410275635514",
      shopifyId: 10410275635514,
      title: "Emerald Executive Two-Tone",
      handle: "success-way-emerald-executive",
      brand: "Stylux",
      sku: "success-way-emerald-executive",
      price: 4199,
      comparePrice: 4999,
      stock: 8,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/15_success-way-emerald-executive_front.png?v=1787641373"
    },
    {
      id: "prod_10410275569978",
      shopifyId: 10410275569978,
      title: "Nautilus 5711 — Black Dial Steel",
      handle: "patek-nautilus-black-steel",
      brand: "Patek Philippe",
      sku: "patek-nautilus-black-steel",
      price: 3699,
      comparePrice: 4999,
      stock: 5,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/14_patek-nautilus-black-steel_front.png?v=1787641373"
    },
    {
      id: "prod_10410275504442",
      shopifyId: 10410275504442,
      title: "Nautilus Gold Bezel Textured Leather",
      handle: "elegance-nautilus-gold-bezel",
      brand: "Patek Philippe",
      sku: "elegance-nautilus-gold-bezel",
      price: 3999,
      comparePrice: 4999,
      stock: 3,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/13_elegance-nautilus-gold-bezel_front.png?v=1787641372"
    },
    {
      id: "prod_10410275471674",
      shopifyId: 10410275471674,
      title: "Nautilus Slate Grey Embossed Leather",
      handle: "elegance-nautilus-slate-grey",
      brand: "Patek Philippe",
      sku: "elegance-nautilus-slate-grey",
      price: 3999,
      comparePrice: 4999,
      stock: 5,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/12_elegance-nautilus-slate-grey_front.png?v=1787641372"
    },
    {
      id: "prod_10410275406138",
      shopifyId: 10410275406138,
      title: "Tank Must — Emerald Green",
      handle: "cartier-tank-emerald",
      brand: "Cartier",
      sku: "cartier-tank-emerald",
      price: 2499,
      comparePrice: 4999,
      stock: 10,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/11_cartier-tank-emerald_front.png?v=1787641372"
    },
    {
      id: "prod_10410275340602",
      shopifyId: 10410275340602,
      title: "Classic Fusion Chrono — Matte Black",
      handle: "hublot-classic-fusion-chrono",
      brand: "Hublot",
      sku: "hublot-classic-fusion-chrono",
      price: 2649,
      comparePrice: 4999,
      stock: 4,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/10_hublot-classic-fusion-chrono_front.png?v=1787641371"
    },
    {
      id: "prod_10410275242298",
      shopifyId: 10410275242298,
      title: "Tank Style Gold Edition Masterlock",
      handle: "cartier-tank-masterlock",
      brand: "Cartier",
      sku: "cartier-tank-masterlock",
      price: 3099,
      comparePrice: 4999,
      stock: 6,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/09_cartier-tank-masterlock_front.png?v=1787641371"
    },
    {
      id: "prod_10410275209530",
      shopifyId: 10410275209530,
      title: "GMT-Master II — Sprite Destro",
      handle: "rolex-gmt-sprite",
      brand: "Rolex",
      sku: "rolex-gmt-sprite",
      price: 4499,
      comparePrice: 4999,
      stock: 8,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/08_rolex-gmt-sprite_front.png?v=1787641371"
    },
    {
      id: "prod_10410275143994",
      shopifyId: 10410275143994,
      title: "GMT-Master II — Batman",
      handle: "rolex-gmt-batman",
      brand: "Rolex",
      sku: "rolex-gmt-batman",
      price: 4499,
      comparePrice: 4999,
      stock: 4,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/07_rolex-gmt-batman_front.png?v=1787641371"
    },
    {
      id: "prod_10410275078458",
      shopifyId: 10410275078458,
      title: "Datejust — Two-Tone Emerald Monogram",
      handle: "rolex-datejust-green",
      brand: "Rolex",
      sku: "rolex-datejust-green",
      price: 3850,
      comparePrice: 4999,
      stock: 6,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/06_rolex-datejust-green_front.png?v=1787641370"
    },
    {
      id: "prod_10410275012922",
      shopifyId: 10410275012922,
      title: "Santos — Aqua Mint Roman Dial",
      handle: "santos-aqua-mint",
      brand: "Cartier",
      sku: "santos-aqua-mint",
      price: 3549,
      comparePrice: 4999,
      stock: 5,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/05_santos-aqua-mint_front.png?v=1787641370"
    },
    {
      id: "prod_10410274947386",
      shopifyId: 10410274947386,
      title: "Modern Minimalist Deep Blue Two-Tone",
      handle: "skmei-minimalist-blue",
      brand: "Stylux",
      sku: "skmei-minimalist-blue",
      price: 4999,
      comparePrice: 4999,
      stock: 7,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/04_skmei-minimalist-blue_front.png?v=1787641370"
    },
    {
      id: "prod_10410274881850",
      shopifyId: 10410274881850,
      title: "Datejust — Ice Blue Jubilee",
      handle: "rolex-datejust-iceblue",
      brand: "Rolex",
      sku: "rolex-datejust-iceblue",
      price: 3850,
      comparePrice: 4999,
      stock: 6,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/03_rolex-datejust-iceblue_front.png?v=1787641370"
    },
    {
      id: "prod_10410274816314",
      shopifyId: 10410274816314,
      title: "Nautilus Classic Charcoal Steel",
      handle: "nautilus-charcoal-steel",
      brand: "Patek Philippe",
      sku: "nautilus-charcoal-steel",
      price: 3999,
      comparePrice: 4999,
      stock: 4,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/02_hoursly-nautilus-charcoal_front.png?v=1787641369"
    },
    {
      id: "prod_10410274750778",
      shopifyId: 10410274750778,
      title: "Tank Solo Gold & White",
      handle: "cartier-tank-goldwhite",
      brand: "Cartier",
      sku: "cartier-tank-goldwhite",
      price: 2599,
      comparePrice: 3399,
      stock: 5,
      lowStockThreshold: 3,
      image: "https://cdn.shopify.com/s/files/1/1013/9444/8698/files/01_cartier-tank-goldwhite_front.png?v=1787641369"
    }
  ];

  // --- 2. INVENTORY STORAGE OPERATIONS & LIVE SHOPIFY CATALOG SYNC ---
  function getShopifyEmbeddedProducts() {
    try {
      const scriptEl = document.getElementById('shopify-live-products-catalog');
      if (scriptEl && scriptEl.textContent) {
        const parsed = JSON.parse(scriptEl.textContent.trim());
        if (Array.isArray(parsed) && parsed.length > 0) {
          return parsed;
        }
      }
    } catch (e) {
      console.warn('[StyluxAdmin] Error reading embedded Shopify catalog:', e);
    }
    return null;
  }

  async function syncWithShopifyCatalog() {
    try {
      const res = await fetch('/products.json?limit=250');
      if (!res.ok) return;
      const data = await res.json();
      if (!data || !Array.isArray(data.products) || data.products.length === 0) return;

      const storedInv = getInventory();
      const storedMap = new Map();
      storedInv.forEach(item => {
        storedMap.set(String(item.shopifyId || item.id), item);
        storedMap.set(item.title.toLowerCase().trim(), item);
      });

      const updated = data.products.map(p => {
        let brand = 'Stylux';
        const t = (p.title + ' ' + (p.vendor || '') + ' ' + (p.tags || []).join(' ')).toLowerCase();
        if (t.includes('rolex') || t.includes('submariner') || t.includes('datejust') || t.includes('gmt') || t.includes('day-date')) brand = 'Rolex';
        else if (t.includes('tissot') || t.includes('prx')) brand = 'Tissot';
        else if (t.includes('hublot') || t.includes('aerofusion') || t.includes('classic fusion') || t.includes('orlinski')) brand = 'Hublot';
        else if (t.includes('cartier') || t.includes('tank') || t.includes('santos')) brand = 'Cartier';
        else if (t.includes('patek') || t.includes('nautilus')) brand = 'Patek Philippe';
        else if (t.includes('royal oak') || t.includes('audemars')) brand = 'Audemars Piguet';
        else if (t.includes('diamond blue')) brand = 'Diamond Blue';

        const variant = (p.variants && p.variants[0]) ? p.variants[0] : {};
        const img = (p.images && p.images[0]) ? p.images[0].src : '';
        const existing = storedMap.get(String(p.id)) || storedMap.get(p.title.toLowerCase().trim());

        return {
          id: 'prod_' + p.id,
          shopifyId: p.id,
          title: p.title,
          handle: p.handle,
          brand: brand,
          sku: variant.sku || p.handle || ('STX-' + p.id.toString().slice(-4)),
          price: existing ? existing.price : (parseFloat(variant.price) || 3499),
          comparePrice: existing ? existing.comparePrice : (parseFloat(variant.compare_at_price) || 4999),
          stock: existing ? existing.stock : (variant.available === false ? 0 : 8),
          lowStockThreshold: 3,
          image: img || (existing ? existing.image : '')
        };
      });

      saveInventory(updated);
      syncFrontEndInventory();
      if (isDashboardOpen) renderDashboardUI();
    } catch (e) {
      console.warn('[StyluxAdmin] Error syncing live Shopify catalog:', e);
    }
  }

  function getInventory() {
    let stored = null;
    try {
      const raw = localStorage.getItem(INVENTORY_STORAGE_KEY);
      if (raw) stored = JSON.parse(raw);
    } catch (e) {
      console.warn('[StyluxAdmin] Error reading inventory database:', e);
    }

    const embedded = getShopifyEmbeddedProducts();
    if (embedded && embedded.length > 0) {
      const storedMap = new Map();
      if (Array.isArray(stored)) {
        stored.forEach(item => {
          storedMap.set(String(item.shopifyId || item.id), item);
          storedMap.set(item.title.toLowerCase().trim(), item);
        });
      }

      const merged = embedded.map(p => {
        const existing = storedMap.get(String(p.shopifyId || p.id)) || storedMap.get(p.title.toLowerCase().trim());
        return {
          id: p.id || ('prod_' + p.shopifyId),
          shopifyId: p.shopifyId,
          title: p.title,
          handle: p.handle,
          brand: p.brand || 'Stylux',
          sku: p.sku || p.handle,
          price: existing ? existing.price : (parseFloat(p.price) || 3499),
          comparePrice: existing ? existing.comparePrice : (parseFloat(p.comparePrice) || 4999),
          stock: existing ? existing.stock : (p.available === false ? 0 : 8),
          lowStockThreshold: 3,
          image: p.image || (existing ? existing.image : '')
        };
      });

      saveInventory(merged);
      return merged;
    }

    if (Array.isArray(stored) && stored.length > 0) {
      return stored;
    }

    saveInventory(INITIAL_INVENTORY);
    return INITIAL_INVENTORY;
  }

  function saveInventory(inventory) {
    try {
      localStorage.setItem(INVENTORY_STORAGE_KEY, JSON.stringify(inventory));
    } catch (e) {
      console.error('[StyluxAdmin] Failed to save inventory:', e);
    }
  }

  function findProductByTitle(title) {
    if (!title) return null;
    const inv = getInventory();
    const cleanTitle = title.toLowerCase().replace(/—|–|-/g, ' ').replace(/\s+/g, ' ').trim();
    
    return inv.find(p => {
      const pClean = p.title.toLowerCase().replace(/—|–|-/g, ' ').replace(/\s+/g, ' ').trim();
      return pClean === cleanTitle || cleanTitle.includes(pClean) || pClean.includes(cleanTitle);
    }) || null;
  }

  function updateStock(productId, newStock) {
    const inv = getInventory();
    const target = inv.find(p => p.id === productId);
    if (!target) return { success: false, message: 'Product not found' };

    const parsed = Math.max(0, parseInt(newStock, 10) || 0);
    target.stock = parsed;
    saveInventory(inv);

    // Sync Front-end immediately
    syncFrontEndInventory();

    // Trigger update events
    window.dispatchEvent(new CustomEvent('stylux:inventory_updated', {
      detail: { product: target, field: 'stock', value: parsed }
    }));

    return { success: true, product: target };
  }

  function updatePrice(productId, newPrice) {
    const inv = getInventory();
    const target = inv.find(p => p.id === productId);
    if (!target) return { success: false, message: 'Product not found' };

    const parsed = Math.max(0, parseFloat(newPrice) || 0);
    target.price = parsed;
    saveInventory(inv);

    // Sync Front-end immediately
    syncFrontEndInventory();

    // Trigger update events
    window.dispatchEvent(new CustomEvent('stylux:inventory_updated', {
      detail: { product: target, field: 'price', value: parsed }
    }));

    return { success: true, product: target };
  }

  function resetInventoryToDefault() {
    saveInventory(INITIAL_INVENTORY);
    syncFrontEndInventory();
    window.dispatchEvent(new CustomEvent('stylux:inventory_updated', { detail: { reset: true } }));
    return INITIAL_INVENTORY;
  }

  // --- 3. METRICS CALCULATIONS ---
  function getMetrics() {
    const orders = (window.StyluxAuth && typeof window.StyluxAuth.getAllOrders === 'function')
      ? window.StyluxAuth.getAllOrders()
      : [];
    const inventory = getInventory();

    const grossSales = orders.reduce((sum, o) => sum + (parseFloat(o.total) || 0), 0);
    const totalOrders = orders.length;

    let processingCount = 0;
    let shippedCount = 0;
    let deliveredCount = 0;

    orders.forEach(o => {
      const st = (o.fulfillmentStatus || '').toLowerCase();
      if (st === 'processing') processingCount++;
      else if (st === 'shipped') shippedCount++;
      else if (st === 'delivered') deliveredCount++;
    });

    const lowStockItems = inventory.filter(p => p.stock > 0 && p.stock <= (p.lowStockThreshold || 3));
    const outOfStockItems = inventory.filter(p => p.stock === 0);

    return {
      grossSales,
      totalOrders,
      processingCount,
      shippedCount,
      deliveredCount,
      lowStockCount: lowStockItems.length,
      outOfStockCount: outOfStockItems.length,
      totalLowAlerts: lowStockItems.length + outOfStockItems.length,
      lowStockItems,
      outOfStockItems
    };
  }

  // --- 4. REAL-TIME FRONT-END SYNCHRONIZATION ---
  function syncFrontEndInventory() {
    const inventory = getInventory();
    const cards = document.querySelectorAll('.group.relative.flex.flex-col, [data-product-card]');

    cards.forEach(card => {
      // Find card title
      const titleEl = card.querySelector('h3, [data-product-title]');
      if (!titleEl) return;
      const title = (titleEl.getAttribute('data-product-title') || titleEl.textContent || '').trim();
      const product = findProductByTitle(title);
      if (!product) return;

      // 1. Stock Indicator: Suppressed on customer-facing storefront cards
      const existingIndicator = card.querySelector('.product-stock-indicator');
      if (existingIndicator) existingIndicator.remove();

      // 2. Card Badge update (Top-Right "Sale" vs "Sold out")
      const badge = card.querySelector('.luxury-card-badge');
      if (badge) {
        if (product.stock === 0) {
          badge.textContent = 'Sold out';
          badge.style.backgroundColor = '#fef2f2';
          badge.style.color = '#991b1b';
          badge.style.borderColor = '#fecaca';
        } else {
          badge.textContent = 'Sale';
          badge.style.backgroundColor = '#ffffff';
          badge.style.color = '#000000';
          badge.style.borderColor = '#e5e7eb';
        }
      }

      // 3. Quick Add Button state
      const quickAddBtn = card.querySelector('button[data-slot="button"]');
      if (quickAddBtn) {
        if (product.stock === 0) {
          quickAddBtn.disabled = true;
          quickAddBtn.style.opacity = '0.5';
          quickAddBtn.style.cursor = 'not-allowed';
          quickAddBtn.style.pointerEvents = 'none';
          quickAddBtn.title = 'Item currently sold out';
          const svg = quickAddBtn.querySelector('svg');
          quickAddBtn.innerHTML = '';
          if (svg) quickAddBtn.appendChild(svg);
          quickAddBtn.appendChild(document.createTextNode('Sold Out'));
        } else {
          quickAddBtn.disabled = false;
          quickAddBtn.style.opacity = '';
          quickAddBtn.style.cursor = 'pointer';
          quickAddBtn.style.pointerEvents = 'auto';
          quickAddBtn.title = 'Quick Add to Bag';
          const svg = quickAddBtn.querySelector('svg');
          quickAddBtn.innerHTML = '';
          if (svg) quickAddBtn.appendChild(svg);
          quickAddBtn.appendChild(document.createTextNode('Quick Add'));
        }
      }

      // 4. Price update
      const activePriceEl = card.querySelector('.luxury-price-active');
      if (activePriceEl) {
        activePriceEl.textContent = `Rs.${product.price.toLocaleString('en-US')}.00`;
      }
    });
  }

  // --- 5. DASHBOARD UI CONTROLLER & ROUTE GUARD ---
  let isDashboardOpen = false;

  function checkAdminAccess() {
    if (!window.StyluxAuth) return false;
    return Boolean(window.StyluxAuth.isAdmin && window.StyluxAuth.isAdmin());
  }

  function showAccessDeniedModal() {
    const deniedModal = document.getElementById('stylux-admin-access-denied');
    if (deniedModal) {
      deniedModal.style.display = 'flex';
      let countdown = 3;
      const countEl = document.getElementById('access-denied-timer');
      if (countEl) countEl.textContent = `${countdown}s`;

      const timer = setInterval(() => {
        countdown--;
        if (countEl) countEl.textContent = `${countdown}s`;
        if (countdown <= 0) {
          clearInterval(timer);
          deniedModal.style.display = 'none';
          if (window.location.hash === '#admin-dashboard') {
            history.replaceState(null, null, ' ');
          }
        }
      }, 1000);
    } else {
      alert('Access Restricted: Administrator credentials required to access the Stylux Command Center.');
      if (window.location.hash === '#admin-dashboard') {
        history.replaceState(null, null, ' ');
      }
    }
  }

  function openDashboard() {
    if (!checkAdminAccess()) {
      if (window.StyluxAccountPortal && typeof window.StyluxAccountPortal.open === 'function') {
        window.StyluxAccountPortal.open();
      } else {
        showAccessDeniedModal();
      }
      return false;
    }

    const modal = document.getElementById('stylux-admin-dashboard-modal');
    if (!modal) return false;

    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    isDashboardOpen = true;

    // Render Dashboard Contents
    renderDashboardUI();
    return true;
  }

  function closeDashboard() {
    const modal = document.getElementById('stylux-admin-dashboard-modal');
    if (modal) modal.style.display = 'none';
    document.body.style.overflow = '';
    isDashboardOpen = false;
    if (window.location.hash === '#admin-dashboard') {
      history.replaceState(null, null, ' ');
    }
  }

  function formatMoney(amount) {
    return 'Rs.' + Math.round(amount).toLocaleString('en-US');
  }

  // Render promo codes and hero slider managers
  function renderDashboardUI() {
    // 1. Render Discounts & Promo Codes Table
    renderDiscountsTable();

    // 2. Render Hero Slider Slides Manager
    renderHeroSlidesManager();
  }

  // --- 5A. DISCOUNTS & PROMO CODES MANAGEMENT ---
  function getDiscounts() {
    if (window.StyluxSharedStore && typeof window.StyluxSharedStore.getDiscounts === 'function') {
      return window.StyluxSharedStore.getDiscounts();
    }
    try {
      const stored = localStorage.getItem('stylux_active_discounts') || localStorage.getItem('stylux_discounts_database');
      if (stored) {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed) && parsed.length > 0) return parsed;
      }
    } catch(e) {}
    return (window.__STYLUX_SHARED_CONFIG__ && window.__STYLUX_SHARED_CONFIG__.activeDiscounts) || [];
  }

  function saveDiscounts(discounts) {
    if (window.StyluxSharedStore && typeof window.StyluxSharedStore.setDiscounts === 'function') {
      window.StyluxSharedStore.setDiscounts(discounts);
    } else {
      try {
        localStorage.setItem('stylux_active_discounts', JSON.stringify(discounts));
        localStorage.setItem('stylux_discounts_database', JSON.stringify(discounts));
        localStorage.setItem('stylux_discounts_initialized', 'true');
        window.dispatchEvent(new CustomEvent('stylux:discounts_updated', { detail: { discounts } }));
      } catch(e) {}
    }
  }

  function renderDiscountsTable() {
    const tableBody = document.getElementById('admin-discounts-table-body');
    const mobileContainer = document.getElementById('admin-discounts-mobile-container');
    if (!tableBody && !mobileContainer) return;

    const discounts = getDiscounts();

    if (discounts.length === 0) {
      const emptyHtmlDesktop = `
        <tr>
          <td colspan="6" style="text-align: center; padding: 3rem 1.5rem; background: #ffffff;">
            <div style="width: 48px; height: 48px; border-radius: 50%; background: #ecfdf5; border: 1px solid #a7f3d0; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 0.75rem; color: #059669;">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
            </div>
            <div style="font-weight: 700; color: #0f172a; font-size: 0.9375rem; margin-bottom: 4px;">No Promo Codes Active</div>
            <div style="color: #64748b; font-size: 0.8125rem; max-width: 460px; margin: 0 auto 1.25rem; line-height: 1.5;">
              Create promo coupons for campaigns, VIP buyers, or seasonal sales. Active codes can be applied immediately by customers in their cart.
            </div>
            <button type="button" class="stylux-pill-btn admin-empty-create-discount-trigger" style="background: #0f172a; color: #ffffff; border-color: #0f172a; padding: 0.55rem 1.25rem; border-radius: 6px; font-size: 0.8125rem; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px;">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              + Create First Promo Code
            </button>
          </td>
        </tr>
      `;

      const emptyHtmlMobile = `
        <div style="text-align: center; padding: 2.25rem 1.25rem; background: #ffffff; border-radius: 12px; border: 1px solid #e2e8f0; margin-top: 0.5rem;">
          <div style="width: 44px; height: 44px; border-radius: 50%; background: #ecfdf5; border: 1px solid #a7f3d0; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 0.75rem; color: #059669;">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
          </div>
          <div style="font-weight: 700; color: #0f172a; font-size: 0.9375rem; margin-bottom: 4px;">No Promo Codes</div>
          <div style="color: #64748b; font-size: 0.8125rem; margin-bottom: 1.25rem; line-height: 1.4;">
            Create discount coupons for shoppers to apply in cart.
          </div>
          <button type="button" class="stylux-pill-btn admin-empty-create-discount-trigger" style="background: #0f172a; color: #ffffff; border-color: #0f172a; padding: 0.65rem 1.25rem; border-radius: 8px; font-size: 0.8125rem; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; width: 100%; justify-content: center;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            + Create New Promo Code
          </button>
        </div>
      `;

      if (tableBody) tableBody.innerHTML = emptyHtmlDesktop;
      if (mobileContainer) mobileContainer.innerHTML = emptyHtmlMobile;

      document.querySelectorAll('.admin-empty-create-discount-trigger').forEach(b => {
        b.onclick = openNewDiscountModal;
      });
      return;
    }

    // Desktop Table Render
    if (tableBody) {
      tableBody.innerHTML = discounts.map((d, idx) => {
        const isPct = (d.type === 'percentage');
        const valText = isPct ? `${d.value}% Off` : `Rs. ${d.value.toLocaleString('en-US')} Off`;
        const typeBadge = isPct ? 'Percentage (%)' : 'Flat (PKR)';

        return `
          <tr style="border-bottom: 1px solid #f1f5f9; background: #ffffff;">
            <td style="padding: 0.75rem 1rem;">
              <span style="font-family: monospace; font-weight: 700; font-size: 0.875rem; color: #047857; background: #ecfdf5; border: 1px solid rgba(16, 185, 129, 0.3); padding: 3px 8px; border-radius: 5px;">
                ${d.code}
              </span>
            </td>
            <td style="padding: 0.75rem 1rem;">
              <span style="font-size: 0.75rem; font-weight: 600; color: #475569; background: #f1f5f9; padding: 2px 7px; border-radius: 4px; border: 1px solid #e2e8f0;">
                ${typeBadge}
              </span>
            </td>
            <td style="padding: 0.75rem 1rem;">
              <strong style="color: #0f172a; font-size: 0.875rem;">${valText}</strong>
            </td>
            <td style="padding: 0.75rem 1rem; color: #334155; font-size: 0.8125rem;">
              ${d.description || 'Promotional campaign discount'}
            </td>
            <td style="padding: 0.75rem 1rem; white-space: nowrap;">
              <button 
                type="button" 
                class="stylux-toggle-discount-btn" 
                data-code="${d.code}"
                style="cursor: pointer; padding: 4px 10px; border-radius: 9999px; font-size: 0.75rem; font-weight: 600; background: ${d.active ? '#dcfce7' : '#f1f5f9'}; color: ${d.active ? '#15803d' : '#64748b'}; border: 1px solid ${d.active ? '#86efac' : '#cbd5e1'}; transition: all 0.2s;"
                title="Click to toggle status"
              >
                ${d.active ? '● Active' : '○ Inactive'}
              </button>
            </td>
            <td style="padding: 0.75rem 1rem; white-space: nowrap;">
              <button 
                type="button" 
                class="stylux-delete-discount-btn" 
                data-code="${d.code}"
                style="padding: 4px 10px; font-size: 0.75rem; font-weight: 600; background: #fff1f2; color: #e11d48; border: 1px solid #fecdd3; border-radius: 4px; cursor: pointer; transition: opacity 0.2s;"
                onmouseover="this.style.opacity='0.8'"
                onmouseout="this.style.opacity='1'"
              >
                Delete
              </button>
            </td>
          </tr>
        `;
      }).join('');
    }

    // Mobile Cards Render
    if (mobileContainer) {
      mobileContainer.innerHTML = discounts.map((d, idx) => {
        const isPct = (d.type === 'percentage');
        const valText = isPct ? `${d.value}% Off` : `Rs. ${d.value.toLocaleString('en-US')} Off`;
        const typeBadge = isPct ? 'Percentage (%)' : 'Flat (PKR)';

        return `
          <div class="stylux-mobile-card" style="background: #ffffff; border: 1px solid #e2e8f0; border-radius: 10px; padding: 0.85rem 1rem; margin-bottom: 0.65rem;">
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 6px;">
              <span style="font-family: monospace; font-weight: 700; font-size: 0.875rem; color: #047857; background: #ecfdf5; border: 1px solid rgba(16, 185, 129, 0.3); padding: 2px 7px; border-radius: 5px;">
                ${d.code}
              </span>
              <button 
                type="button" 
                class="stylux-toggle-discount-btn" 
                data-code="${d.code}"
                style="cursor: pointer; padding: 3px 8px; border-radius: 9999px; font-size: 0.6875rem; font-weight: 600; background: ${d.active ? '#dcfce7' : '#f1f5f9'}; color: ${d.active ? '#15803d' : '#64748b'}; border: 1px solid ${d.active ? '#86efac' : '#cbd5e1'};"
              >
                ${d.active ? '● Active' : '○ Inactive'}
              </button>
            </div>
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 4px;">
              <strong style="color: #0f172a; font-size: 0.9375rem;">${valText}</strong>
              <span style="font-size: 0.6875rem; font-weight: 600; color: #475569; background: #f1f5f9; padding: 2px 6px; border-radius: 4px;">${typeBadge}</span>
            </div>
            <div style="color: #64748b; font-size: 0.75rem; margin-bottom: 8px; line-height: 1.35;">
              ${d.description || 'Promotional campaign discount'}
            </div>
            <div style="display: flex; align-items: center; justify-content: flex-end; padding-top: 6px; border-top: 1px solid #f1f5f9;">
              <button 
                type="button" 
                class="stylux-delete-discount-btn" 
                data-code="${d.code}"
                style="padding: 4px 12px; font-size: 0.75rem; font-weight: 600; background: #fff1f2; color: #e11d48; border: 1px solid #fecdd3; border-radius: 6px; cursor: pointer;"
              >
                Delete Promo Code
              </button>
            </div>
          </div>
        `;
      }).join('');
    }

    // Bind Toggle Active
    document.querySelectorAll('.stylux-toggle-discount-btn').forEach(btn => {
      btn.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const code = btn.dataset.code;
        const list = getDiscounts();
        const target = list.find(d => d.code === code);
        if (target) {
          target.active = !target.active;
          saveDiscounts(list);
          showToast(`Promo code "${code}" is now ${target.active ? 'Active' : 'Inactive'}`, 'info');
          renderDiscountsTable();
        }
      };
    });

    // Bind Delete
    document.querySelectorAll('.stylux-delete-discount-btn').forEach(btn => {
      btn.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const code = btn.dataset.code;
        if (confirm(`Delete promo code "${code}" permanently?`)) {
          let list = getDiscounts();
          list = list.filter(d => d.code !== code);
          saveDiscounts(list);
          showToast(`Promo code "${code}" removed from system`, 'info');
          renderDiscountsTable();
        }
      };
    });
  }

  function renderOrdersTable(filterStatus = 'all', searchQuery = '') {
    const tableBody = document.getElementById('admin-orders-table-body');
    const mobileContainer = document.getElementById('admin-orders-mobile-container');
    if (!tableBody && !mobileContainer) return;

    const orders = (window.StyluxAuth && typeof window.StyluxAuth.getAllOrders === 'function')
      ? window.StyluxAuth.getAllOrders()
      : [];

    const query = searchQuery.toLowerCase().trim();
    const filtered = orders.filter(order => {
      const matchStatus = (filterStatus === 'all') || (order.fulfillmentStatus || '').toLowerCase() === filterStatus.toLowerCase();
      const matchQuery = !query || 
        (order.id || '').toLowerCase().includes(query) ||
        (order.customerName || '').toLowerCase().includes(query) ||
        (order.userEmail || '').toLowerCase().includes(query) ||
        (order.shippingAddress && order.shippingAddress.city && order.shippingAddress.city.toLowerCase().includes(query));
      return matchStatus && matchQuery;
    });

    if (filtered.length === 0) {
      if (orders.length === 0) {
        if (tableBody) {
          tableBody.innerHTML = `
            <tr>
              <td colspan="7" style="text-align: center; padding: 3rem 1.5rem; background: #ffffff;">
                <div style="width: 48px; height: 48px; border-radius: 50%; background: #f8fafc; border: 1px solid #e2e8f0; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 0.75rem; color: #94a3b8;">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
                </div>
                <div style="font-weight: 700; color: #0f172a; font-size: 0.9375rem; margin-bottom: 4px;">No Storefront Orders Recorded Yet</div>
                <div style="color: #64748b; font-size: 0.8125rem; max-width: 460px; margin: 0 auto 1.25rem; line-height: 1.5;">
                  Orders placed by shoppers through the storefront checkout will automatically stream here. You can also log manual customer orders (phone, WhatsApp, COD) directly into the database.
                </div>
                <button type="button" class="stylux-pill-btn admin-empty-create-order-trigger" style="background: #0f172a; color: #ffffff; border-color: #0f172a; padding: 0.5rem 1.25rem; border-radius: 6px; font-size: 0.8125rem; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px;">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                  + Log Real Customer Order
                </button>
              </td>
            </tr>
          `;
        }
        if (mobileContainer) {
          mobileContainer.innerHTML = `
            <div style="text-align: center; padding: 2.25rem 1.25rem; background: #ffffff; border-radius: 12px; border: 1px solid #e2e8f0; margin-top: 0.5rem;">
              <div style="width: 44px; height: 44px; border-radius: 50%; background: #f8fafc; border: 1px solid #e2e8f0; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 0.75rem; color: #94a3b8;">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
              </div>
              <div style="font-weight: 700; color: #0f172a; font-size: 0.9375rem; margin-bottom: 4px;">No Orders Recorded Yet</div>
              <div style="color: #64748b; font-size: 0.8125rem; margin-bottom: 1.25rem; line-height: 1.4;">
                Shopper orders will stream here automatically. You can also log manual customer orders.
              </div>
              <button type="button" class="stylux-pill-btn admin-empty-create-order-trigger" style="background: #0f172a; color: #ffffff; border-color: #0f172a; padding: 0.65rem 1.25rem; border-radius: 8px; font-size: 0.8125rem; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; width: 100%; justify-content: center;">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                + Log Real Customer Order
              </button>
            </div>
          `;
        }
        document.querySelectorAll('.admin-empty-create-order-trigger').forEach(btn => {
          btn.onclick = openNewOrderModal;
        });
        return;
      }

      if (tableBody) {
        tableBody.innerHTML = `
          <tr>
            <td colspan="7" style="text-align: center; padding: 2.5rem; color: #71717a; font-size: 0.875rem;">
              No orders found matching the filter criteria.
            </td>
          </tr>
        `;
      }
      if (mobileContainer) {
        mobileContainer.innerHTML = `
          <div style="text-align: center; padding: 2rem 1rem; color: #71717a; font-size: 0.875rem; background: #ffffff; border-radius: 12px; border: 1px solid #e2e8f0;">
            No orders found matching the filter criteria.
          </div>
        `;
      }
      return;
    }

    // 1. Render Desktop Spreadsheet Rows
    if (tableBody) {
      tableBody.innerHTML = filtered.map(order => {
        const status = order.fulfillmentStatus || 'Processing';
        let statusBg = '#eff6ff';
        let statusColor = '#1d4ed8';
        let statusBorder = '#bfdbfe';

        if (status === 'Shipped') {
          statusBg = '#f5f3ff';
          statusColor = '#6d28d9';
          statusBorder = '#ddd6fe';
        } else if (status === 'Delivered') {
          statusBg = '#ecfdf5';
          statusColor = '#047857';
          statusBorder = '#a7f3d0';
        }

        const itemsSummary = (order.items || []).map(i => `${i.name} (x${i.quantity})`).join(', ');
        const city = (order.shippingAddress && order.shippingAddress.city) ? order.shippingAddress.city : 'Pakistan';

        return `
          <tr style="border-bottom: 1px solid #f1f5f9; transition: background-color 0.15s; background-color: #ffffff;" onmouseover="this.style.backgroundColor='#f8fafc'" onmouseout="this.style.backgroundColor='#ffffff'">
            <td style="padding: 0.85rem 1rem; font-family: monospace; font-weight: 700; color: #b45309; font-size: 0.8125rem;">
              #${order.id}
            </td>
            <td style="padding: 0.85rem 1rem; color: #64748b; font-size: 0.8125rem; white-space: nowrap;">
              ${order.dateFormatted || 'Recently'}
            </td>
            <td style="padding: 0.85rem 1rem;">
              <div style="font-weight: 600; color: #0f172a; font-size: 0.8125rem;">${order.customerName || 'Customer'}</div>
              <div style="color: #64748b; font-size: 0.75rem;">${city} • ${order.userEmail || ''}</div>
            </td>
            <td style="padding: 0.85rem 1rem; max-width: 260px;">
              <div style="color: #334155; font-size: 0.8125rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" title="${itemsSummary}">
                ${itemsSummary || 'Horology Timepiece'}
              </div>
              <div style="color: #94a3b8; font-size: 0.75rem;">${(order.items || []).length} Item(s)</div>
            </td>
            <td style="padding: 0.85rem 1rem; font-weight: 700; color: #0f172a; font-size: 0.875rem; white-space: nowrap;">
              ${formatMoney(order.total || 0)}
            </td>
            <td style="padding: 0.85rem 1rem; color: #475569; font-size: 0.75rem; white-space: nowrap;">
              <span style="display: inline-block; padding: 2px 8px; border-radius: 4px; background: #f1f5f9; color: #334155; border: 1px solid #e2e8f0; font-weight: 500;">
                ${order.paymentMethod || 'COD'}
              </span>
            </td>
            <td style="padding: 0.85rem 1rem; white-space: nowrap;">
              <select 
                class="stylux-order-status-select" 
                data-order-id="${order.id}" 
                style="
                  padding: 0.35rem 0.65rem;
                  font-size: 0.75rem;
                  font-weight: 600;
                  border-radius: 6px;
                  cursor: pointer;
                  outline: none;
                  background-color: ${statusBg};
                  color: ${statusColor};
                  border: 1px solid ${statusBorder};
                  transition: all 0.2s;
                "
              >
                <option value="Processing" ${status === 'Processing' ? 'selected' : ''}>⏳ Processing</option>
                <option value="Shipped" ${status === 'Shipped' ? 'selected' : ''}>🚚 Shipped</option>
                <option value="Delivered" ${status === 'Delivered' ? 'selected' : ''}>✅ Delivered</option>
              </select>
            </td>
          </tr>
        `;
      }).join('');
    }

    // 2. Render Mobile Native Touch Cards
    if (mobileContainer) {
      mobileContainer.innerHTML = filtered.map(order => {
        const status = order.fulfillmentStatus || 'Processing';
        let statusBg = '#eff6ff';
        let statusColor = '#1d4ed8';
        let statusBorder = '#bfdbfe';

        if (status === 'Shipped') {
          statusBg = '#f5f3ff';
          statusColor = '#6d28d9';
          statusBorder = '#ddd6fe';
        } else if (status === 'Delivered') {
          statusBg = '#ecfdf5';
          statusColor = '#047857';
          statusBorder = '#a7f3d0';
        }

        const itemsSummary = (order.items || []).map(i => `${i.name} (x${i.quantity})`).join(', ');
        const city = (order.shippingAddress && order.shippingAddress.city) ? order.shippingAddress.city : 'Pakistan';

        return `
          <div class="stylux-mobile-card">
            <div class="stylux-m-card-header">
              <div>
                <span class="stylux-m-order-id">#${order.id}</span>
                <span class="stylux-m-order-date">${order.dateFormatted || 'Recently'}</span>
              </div>
              <select 
                class="stylux-order-status-select" 
                data-order-id="${order.id}" 
                style="
                  padding: 0.38rem 0.65rem;
                  font-size: 0.75rem;
                  font-weight: 700;
                  border-radius: 8px;
                  cursor: pointer;
                  outline: none;
                  background-color: ${statusBg};
                  color: ${statusColor};
                  border: 1px solid ${statusBorder};
                  min-height: 32px;
                "
              >
                <option value="Processing" ${status === 'Processing' ? 'selected' : ''}>⏳ Processing</option>
                <option value="Shipped" ${status === 'Shipped' ? 'selected' : ''}>🚚 Shipped</option>
                <option value="Delivered" ${status === 'Delivered' ? 'selected' : ''}>✅ Delivered</option>
              </select>
            </div>

            <div style="display: flex; align-items: baseline; justify-content: space-between; gap: 8px; margin-bottom: 4px;">
              <div style="font-weight: 700; color: #0f172a; font-size: 0.9375rem;">${order.customerName || 'Customer'}</div>
              <span class="stylux-m-badge-city">${city}</span>
            </div>
            <div style="color: #64748b; font-size: 0.75rem; margin-bottom: 10px;">${order.userEmail || order.phoneNumber || ''}</div>

            <div style="background: #f8fafc; border: 1px solid #f1f5f9; border-radius: 8px; padding: 8px 10px; margin-bottom: 12px;">
              <div style="color: #334155; font-size: 0.8125rem; font-weight: 500; line-height: 1.35;">
                ${itemsSummary || 'Horology Timepiece'}
              </div>
              <div style="color: #94a3b8; font-size: 0.75rem; margin-top: 3px;">${(order.items || []).length} Item(s)</div>
            </div>

            <div class="stylux-m-card-footer">
              <div>
                <div style="font-size: 0.6875rem; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; font-weight: 600;">Grand Total</div>
                <div class="stylux-m-order-total">${formatMoney(order.total || 0)}</div>
              </div>
              <span class="stylux-m-badge-payment">${order.paymentMethod || 'COD'}</span>
            </div>
          </div>
        `;
      }).join('');
    }

    // Bind dropdown change listeners across both desktop and mobile
    document.querySelectorAll('.stylux-order-status-select').forEach(select => {
      select.onchange = (e) => {
        const orderId = select.dataset.orderId;
        const newStatus = e.target.value;

        if (window.StyluxAuth && typeof window.StyluxAuth.updateOrderStatus === 'function') {
          const res = window.StyluxAuth.updateOrderStatus(orderId, newStatus);
          if (res.success) {
            showToast(`Order #${orderId} status updated to "${newStatus}"`, 'success');
            renderDashboardUI();
          } else {
            showToast(res.message || 'Failed to update order status', 'error');
          }
        }
      };
    });
  }

  function renderInventoryTable(filterBrand = 'all', searchQuery = '') {
    const tableBody = document.getElementById('admin-inventory-table-body');
    const mobileContainer = document.getElementById('admin-inventory-mobile-container');
    if (!tableBody && !mobileContainer) return;

    const inventory = getInventory();
    const query = searchQuery.toLowerCase().trim();

    const filtered = inventory.filter(item => {
      const matchBrand = (filterBrand === 'all') || (item.brand || '').toLowerCase() === filterBrand.toLowerCase();
      const matchQuery = !query ||
        item.title.toLowerCase().includes(query) ||
        item.brand.toLowerCase().includes(query) ||
        (item.sku && item.sku.toLowerCase().includes(query));
      return matchBrand && matchQuery;
    });

    if (filtered.length === 0) {
      if (tableBody) {
        tableBody.innerHTML = `
          <tr>
            <td colspan="6" style="text-align: center; padding: 2.5rem; color: #94a3b8; font-size: 0.875rem;">
              No inventory items found.
            </td>
          </tr>
        `;
      }
      if (mobileContainer) {
        mobileContainer.innerHTML = `
          <div style="text-align: center; padding: 2rem 1rem; color: #94a3b8; font-size: 0.875rem; background: #ffffff; border-radius: 12px; border: 1px solid #e2e8f0;">
            No inventory items found.
          </div>
        `;
      }
      return;
    }

    // 1. Render Desktop Table Rows
    if (tableBody) {
      tableBody.innerHTML = filtered.map(item => {
        let statusBadge = `<span style="padding: 3px 8px; border-radius: 9999px; font-size: 0.75rem; font-weight: 600; background: #dcfce7; color: #15803d; border: 1px solid #bbf7d0;">● In Stock</span>`;
        if (item.stock === 0) {
          statusBadge = `<span style="padding: 3px 8px; border-radius: 9999px; font-size: 0.75rem; font-weight: 600; background: #fee2e2; color: #b91c1c; border: 1px solid #fecaca;">✕ Sold Out</span>`;
        } else if (item.stock <= (item.lowStockThreshold || 3)) {
          statusBadge = `<span style="padding: 3px 8px; border-radius: 9999px; font-size: 0.75rem; font-weight: 600; background: #fef3c7; color: #b45309; border: 1px solid #fde68a;">⚡ Low Stock</span>`;
        }

        return `
          <tr style="border-bottom: 1px solid #f1f5f9; transition: background-color 0.15s; background-color: #ffffff;" onmouseover="this.style.backgroundColor='#f8fafc'" onmouseout="this.style.backgroundColor='#ffffff'">
            <td style="padding: 0.85rem 1rem;">
              <div style="display: flex; align-items: center; gap: 12px;">
                <img src="${item.image}" alt="${item.title}" style="width: 38px; height: 38px; border-radius: 6px; object-fit: cover; border: 1px solid #e2e8f0; background: #f8fafc;" onerror="this.src='https://placehold.co/72x72/f8fafc/000000?text=Watch'">
                <div>
                  <div style="font-weight: 600; color: #0f172a; font-size: 0.8125rem; line-height: 1.3;">${item.title}</div>
                  <div style="color: #64748b; font-size: 0.75rem; font-family: monospace;">SKU: ${item.sku}</div>
                </div>
              </div>
            </td>
            <td style="padding: 0.85rem 1rem; color: #475569; font-size: 0.8125rem; font-weight: 500;">
              ${item.brand}
            </td>
            <td style="padding: 0.85rem 1rem; white-space: nowrap;">
              <div style="display: flex; align-items: center; gap: 6px;">
                <span style="color: #64748b; font-size: 0.8125rem; font-weight: 500;">Rs.</span>
                <input 
                  type="number" 
                  class="stylux-admin-price-input" 
                  data-product-id="${item.id}" 
                  value="${item.price}" 
                  min="0" 
                  step="50"
                  style="width: 90px; padding: 4px 8px; font-size: 0.8125rem; font-weight: 600; color: #0f172a; background: #ffffff; border: 1px solid #cbd5e1; border-radius: 4px; outline: none; transition: border-color 0.2s;"
                  onfocus="this.style.borderColor='#0f172a'"
                  onblur="this.style.borderColor='#cbd5e1'"
                />
              </div>
            </td>
            <td style="padding: 0.85rem 1rem; white-space: nowrap;">
              <!-- Interactive Stock Stepper -->
              <div style="display: inline-flex; align-items: center; border: 1px solid #cbd5e1; border-radius: 6px; overflow: hidden; background: #f8fafc;">
                <button 
                  type="button" 
                  class="stylux-stock-btn-minus" 
                  data-product-id="${item.id}" 
                  style="width: 28px; height: 28px; background: transparent; border: none; color: #475569; cursor: pointer; font-weight: bold; font-size: 14px;"
                  title="Decrease stock"
                >−</button>
                <input 
                  type="number" 
                  class="stylux-admin-stock-input" 
                  data-product-id="${item.id}" 
                  value="${item.stock}" 
                  min="0" 
                  style="width: 44px; height: 28px; text-align: center; border: none; background: #ffffff; color: #0f172a; font-weight: 700; font-size: 0.8125rem; outline: none; border-left: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0;"
                />
                <button 
                  type="button" 
                  class="stylux-stock-btn-plus" 
                  data-product-id="${item.id}" 
                  style="width: 28px; height: 28px; background: transparent; border: none; color: #475569; cursor: pointer; font-weight: bold; font-size: 14px;"
                  title="Increase stock"
                >+</button>
              </div>
            </td>
            <td style="padding: 0.85rem 1rem; white-space: nowrap;">
              ${statusBadge}
            </td>
            <td style="padding: 0.85rem 1rem; white-space: nowrap;">
              <button 
                type="button" 
                class="stylux-admin-save-item-btn" 
                data-product-id="${item.id}" 
                style="padding: 5px 12px; font-size: 0.75rem; font-weight: 600; background: #0f172a; color: #ffffff; border: none; border-radius: 4px; cursor: pointer; transition: opacity 0.2s;"
                onmouseover="this.style.opacity='0.85'"
                onmouseout="this.style.opacity='1'"
              >
                Save
              </button>
            </td>
          </tr>
        `;
      }).join('');
    }

    // 2. Render Mobile Cards
    if (mobileContainer) {
      mobileContainer.innerHTML = filtered.map(item => {
        let statusBadge = `<span class="stylux-m-badge-stock stock-in">● In Stock</span>`;
        if (item.stock === 0) {
          statusBadge = `<span class="stylux-m-badge-stock stock-out">✕ Sold Out</span>`;
        } else if (item.stock <= (item.lowStockThreshold || 3)) {
          statusBadge = `<span class="stylux-m-badge-stock stock-low">⚡ Low Stock (${item.stock})</span>`;
        }

        return `
          <div class="stylux-mobile-card" data-product-id="${item.id}">
            <div style="display: flex; gap: 12px; align-items: center; margin-bottom: 12px;">
              <img src="${item.image}" alt="${item.title}" class="stylux-m-inv-thumb" onerror="this.src='https://placehold.co/72x72/f8fafc/000000?text=Watch'">
              <div style="flex: 1; min-width: 0;">
                <div style="display: flex; align-items: center; justify-content: space-between; gap: 6px;">
                  <span style="font-size: 0.6875rem; font-weight: 700; color: #b45309; text-transform: uppercase; letter-spacing: 0.5px;">${item.brand}</span>
                  ${statusBadge}
                </div>
                <div style="font-weight: 700; color: #0f172a; font-size: 0.875rem; line-height: 1.25; margin-top: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${item.title}</div>
                <div style="color: #64748b; font-size: 0.75rem; font-family: monospace; margin-top: 2px;">SKU: ${item.sku}</div>
              </div>
            </div>

            <div class="stylux-m-inv-controls">
              <div class="stylux-m-price-box">
                <span class="currency-prefix">Rs.</span>
                <input 
                  type="number" 
                  class="stylux-admin-price-input" 
                  data-product-id="${item.id}" 
                  value="${item.price}" 
                  min="0" 
                  step="50"
                />
              </div>

              <div class="stylux-m-stepper">
                <button 
                  type="button" 
                  class="stylux-stock-btn-minus" 
                  data-product-id="${item.id}" 
                  title="Decrease stock"
                >−</button>
                <input 
                  type="number" 
                  class="stylux-admin-stock-input" 
                  data-product-id="${item.id}" 
                  value="${item.stock}" 
                  min="0" 
                />
                <button 
                  type="button" 
                  class="stylux-stock-btn-plus" 
                  data-product-id="${item.id}" 
                  title="Increase stock"
                >+</button>
              </div>

              <button 
                type="button" 
                class="stylux-admin-save-item-btn stylux-m-save-btn" 
                data-product-id="${item.id}"
              >
                Save
              </button>
            </div>
          </div>
        `;
      }).join('');
    }

    // Bind Stock Steppers & Inputs across both desktop and mobile
    document.querySelectorAll('.stylux-stock-btn-minus').forEach(btn => {
      btn.onclick = (e) => {
        e.preventDefault();
        const id = btn.dataset.productId;
        const parent = btn.closest('.stylux-m-inv-controls') || btn.closest('tr') || document;
        const input = parent.querySelector(`.stylux-admin-stock-input[data-product-id="${id}"]`) || document.querySelector(`.stylux-admin-stock-input[data-product-id="${id}"]`);
        if (!input) return;
        const current = Math.max(0, parseInt(input.value, 10) - 1);
        input.value = current;
        updateStock(id, current);
        showToast(`Stock updated to ${current}`, 'info');
        renderDashboardUI();
      };
    });

    document.querySelectorAll('.stylux-stock-btn-plus').forEach(btn => {
      btn.onclick = (e) => {
        e.preventDefault();
        const id = btn.dataset.productId;
        const parent = btn.closest('.stylux-m-inv-controls') || btn.closest('tr') || document;
        const input = parent.querySelector(`.stylux-admin-stock-input[data-product-id="${id}"]`) || document.querySelector(`.stylux-admin-stock-input[data-product-id="${id}"]`);
        if (!input) return;
        const current = parseInt(input.value, 10) + 1;
        input.value = current;
        updateStock(id, current);
        showToast(`Stock updated to ${current}`, 'info');
        renderDashboardUI();
      };
    });

    document.querySelectorAll('.stylux-admin-save-item-btn').forEach(btn => {
      btn.onclick = (e) => {
        e.preventDefault();
        const id = btn.dataset.productId;
        const parent = btn.closest('.stylux-mobile-card') || btn.closest('tr') || document;
        const priceInput = parent.querySelector(`.stylux-admin-price-input[data-product-id="${id}"]`) || document.querySelector(`.stylux-admin-price-input[data-product-id="${id}"]`);
        const stockInput = parent.querySelector(`.stylux-admin-stock-input[data-product-id="${id}"]`) || document.querySelector(`.stylux-admin-stock-input[data-product-id="${id}"]`);

        if (priceInput && stockInput) {
          const newPrice = parseFloat(priceInput.value) || 0;
          const newStock = parseInt(stockInput.value, 10) || 0;

          updatePrice(id, newPrice);
          updateStock(id, newStock);
          showToast(`Saved: Rs.${newPrice.toLocaleString()} • ${newStock} in stock`, 'success');
          renderDashboardUI();
        }
      };
    });
  }

  // --- 5B. REAL CUSTOMER ORDER MODAL & CREATION ---
  function populateNewOrderProductDropdown() {
    const select = document.getElementById('admin-new-order-product');
    if (!select) return;

    const inventory = getInventory();
    select.innerHTML = inventory.map(item => `
      <option value="${item.id}" data-price="${item.price}" data-stock="${item.stock}">
        ${item.title} (${item.brand}) — Rs. ${item.price.toLocaleString()} [${item.stock} in stock]
      </option>
    `).join('');

    // Trigger price change on initial option
    const firstOption = select.options[0];
    if (firstOption) {
      const unitPriceInput = document.getElementById('admin-new-order-unit-price');
      if (unitPriceInput) unitPriceInput.value = firstOption.dataset.price || 3499;
      updateNewOrderTotal();
    }
  }

  function updateNewOrderTotal() {
    const qtyInput = document.getElementById('admin-new-order-qty');
    const priceInput = document.getElementById('admin-new-order-unit-price');
    const totalDisplay = document.getElementById('admin-new-order-total-display');
    if (!qtyInput || !priceInput || !totalDisplay) return;

    const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    const price = Math.max(0, parseFloat(priceInput.value) || 0);
    totalDisplay.textContent = formatMoney(qty * price);
  }

  function openNewOrderModal() {
    const modal = document.getElementById('stylux-admin-new-order-modal');
    if (!modal) return;
    populateNewOrderProductDropdown();
    modal.style.display = 'flex';
  }

  function closeNewOrderModal() {
    const modal = document.getElementById('stylux-admin-new-order-modal');
    if (modal) modal.style.display = 'none';
  }

  function setupNewOrderModalEvents() {
    const openBtn = document.getElementById('admin-open-create-order-btn');
    if (openBtn) openBtn.onclick = openNewOrderModal;

    const closeBtn = document.getElementById('admin-close-order-modal-btn');
    if (closeBtn) closeBtn.onclick = closeNewOrderModal;

    const cancelBtn = document.getElementById('admin-cancel-order-modal-btn');
    if (cancelBtn) cancelBtn.onclick = closeNewOrderModal;

    const productSelect = document.getElementById('admin-new-order-product');
    if (productSelect) {
      productSelect.onchange = () => {
        const selectedOpt = productSelect.options[productSelect.selectedIndex];
        if (selectedOpt) {
          const priceInput = document.getElementById('admin-new-order-unit-price');
          if (priceInput) priceInput.value = selectedOpt.dataset.price || 3499;
          updateNewOrderTotal();
        }
      };
    }

    const qtyInput = document.getElementById('admin-new-order-qty');
    if (qtyInput) qtyInput.oninput = updateNewOrderTotal;

    const priceInput = document.getElementById('admin-new-order-unit-price');
    if (priceInput) priceInput.oninput = updateNewOrderTotal;

    const form = document.getElementById('stylux-admin-new-order-form');
    if (form) {
      form.onsubmit = (e) => {
        e.preventDefault();

        const productSelect = document.getElementById('admin-new-order-product');
        const selectedId = productSelect ? productSelect.value : '';
        const inventory = getInventory();
        const selectedProduct = inventory.find(p => p.id === selectedId) || inventory[0];

        if (!selectedProduct) {
          showToast('Please select a valid timepiece', 'error');
          return;
        }

        const qty = Math.max(1, parseInt(document.getElementById('admin-new-order-qty')?.value, 10) || 1);
        const unitPrice = Math.max(0, parseFloat(document.getElementById('admin-new-order-unit-price')?.value) || selectedProduct.price);
        const customerName = (document.getElementById('admin-new-order-name')?.value || '').trim();
        const phone = (document.getElementById('admin-new-order-phone')?.value || '').trim();
        const city = (document.getElementById('admin-new-order-city')?.value || '').trim();
        const address = (document.getElementById('admin-new-order-address')?.value || '').trim();
        const paymentMethod = document.getElementById('admin-new-order-payment')?.value || 'Cash on Delivery (COD)';
        const status = document.getElementById('admin-new-order-status')?.value || 'Processing';

        const totalPrice = qty * unitPrice;
        const now = new Date();
        const dateFormatted = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(now);
        const orderId = 'STX-' + Math.floor(10000 + Math.random() * 90000);

        const newOrder = {
          id: orderId,
          customerName: customerName,
          userEmail: phone,
          phoneNumber: phone,
          dateFormatted: dateFormatted,
          createdAt: Date.now(),
          total: totalPrice,
          subtotal: totalPrice,
          discount: 0,
          paymentMethod: paymentMethod,
          fulfillmentStatus: status,
          items: [{
            id: selectedProduct.id,
            shopifyId: selectedProduct.shopifyId,
            name: selectedProduct.title,
            price: unitPrice,
            quantity: qty,
            sku: selectedProduct.sku,
            image: selectedProduct.image
          }],
          shippingAddress: {
            street: address,
            city: city,
            province: city,
            postalCode: '75000'
          }
        };

        // Save order into real orders storage
        let allOrders = [];
        try {
          const raw = localStorage.getItem('stylux_orders_database');
          if (raw) allOrders = JSON.parse(raw);
        } catch (err) {}
        allOrders.unshift(newOrder);
        try {
          localStorage.setItem('stylux_orders_database', JSON.stringify(allOrders));
        } catch (err) {}

        // Decrement product stock in inventory tracking database
        updateStock(selectedProduct.id, Math.max(0, (selectedProduct.stock || 0) - qty));

        closeNewOrderModal();
        form.reset();
        showToast(`Real customer order #${orderId} logged successfully!`, 'success');

        // Re-render UI and fire global update event
        window.dispatchEvent(new CustomEvent('stylux:order_status_updated'));
        renderDashboardUI();
      };
    }
  }

  // --- 5C. PROMO CODES & DISCOUNTS MANAGEMENT ENGINE ---
  const DISCOUNTS_KEY = 'stylux_discounts_database';
  const DISCOUNTS_INIT_KEY = 'stylux_discounts_initialized';

  function getDiscounts() {
    if (window.StyluxSharedStore && typeof window.StyluxSharedStore.getDiscounts === 'function') {
      return window.StyluxSharedStore.getDiscounts();
    }
    try {
      const isInit = localStorage.getItem(DISCOUNTS_INIT_KEY);
      const data = localStorage.getItem(DISCOUNTS_KEY);
      if (data !== null) {
        const parsed = JSON.parse(data);
        if (Array.isArray(parsed)) return parsed;
      }
      if (isInit === 'true') {
        return [];
      }
    } catch (e) {}
    return (window.__STYLUX_SHARED_CONFIG__ && window.__STYLUX_SHARED_CONFIG__.activeDiscounts) || [
      { code: 'WELCOME10', type: 'percentage', value: 10, active: true, description: '10% Welcome Discount' },
      { code: 'VIP25', type: 'percentage', value: 25, active: true, description: '25% VIP Collector Privilege' },
      { code: 'STYLUX500', type: 'flat', value: 500, active: true, description: 'Flat Rs. 500 Off' }
    ];
  }

  function saveDiscounts(discounts) {
    if (window.StyluxSharedStore && typeof window.StyluxSharedStore.setDiscounts === 'function') {
      window.StyluxSharedStore.setDiscounts(discounts);
    } else {
      try {
        localStorage.setItem(DISCOUNTS_KEY, JSON.stringify(discounts));
        localStorage.setItem(DISCOUNTS_INIT_KEY, 'true');
        window.dispatchEvent(new CustomEvent('stylux:discounts_updated', { detail: { discounts } }));
      } catch (e) {}
    }
  }

  function renderDiscountsTable() {
    // Re-wire open create promo code button whenever discounts view renders
    const createBtn = document.getElementById('admin-open-create-discount-btn');
    if (createBtn) createBtn.onclick = openNewDiscountModal;

    const tableBody = document.getElementById('admin-discounts-table-body');
    const mobileContainer = document.getElementById('admin-discounts-mobile-container');
    if (!tableBody && !mobileContainer) return;

    const discounts = getDiscounts();

    if (discounts.length === 0) {
      if (tableBody) {
        tableBody.innerHTML = `
          <tr>
            <td colspan="6" style="text-align: center; padding: 2.5rem; color: #94a3b8; font-size: 0.875rem;">
              No promo codes found. Click "+ Create New Promo Code" above to create your first discount offer.
            </td>
          </tr>
        `;
      }
      if (mobileContainer) {
        mobileContainer.innerHTML = `
          <div style="text-align: center; padding: 2rem 1rem; color: #94a3b8; font-size: 0.875rem; background: #ffffff; border-radius: 12px; border: 1px solid #e2e8f0;">
            No promo codes found. Click "+ Create New Promo Code" above to create your first discount offer.
          </div>
        `;
      }
      return;
    }

    // 1. Desktop Table
    if (tableBody) {
      tableBody.innerHTML = discounts.map((d, index) => {
        const isPercent = d.type === 'percentage';
        const formattedValue = isPercent ? `${d.value}% Off` : `Rs.${Number(d.value).toLocaleString()} Off`;
        const isActive = d.active !== false;

        return `
          <tr style="border-bottom: 1px solid #f1f5f9; transition: background-color 0.15s; background-color: #ffffff;" onmouseover="this.style.backgroundColor='#f8fafc'" onmouseout="this.style.backgroundColor='#ffffff'">
            <td style="padding: 0.85rem 1rem;">
              <div style="display: flex; align-items: center; gap: 8px;">
                <span style="font-family: monospace; font-weight: 700; font-size: 0.875rem; color: #0f172a; background: #f1f5f9; padding: 3px 8px; border-radius: 4px; border: 1px solid #e2e8f0; letter-spacing: 0.5px;">
                  ${d.code}
                </span>
              </div>
            </td>
            <td style="padding: 0.85rem 1rem; color: #475569; font-size: 0.8125rem;">
              <span style="display: inline-block; padding: 2px 8px; border-radius: 4px; background: ${isPercent ? '#eff6ff' : '#f5f3ff'}; color: ${isPercent ? '#1d4ed8' : '#6d28d9'}; border: 1px solid ${isPercent ? '#bfdbfe' : '#ddd6fe'}; font-weight: 600; font-size: 0.75rem;">
                ${isPercent ? 'Percentage (%)' : 'Flat (PKR)'}
              </span>
            </td>
            <td style="padding: 0.85rem 1rem; font-weight: 700; color: #059669; font-size: 0.875rem; white-space: nowrap;">
              ${formattedValue}
            </td>
            <td style="padding: 0.85rem 1rem; color: #334155; font-size: 0.8125rem;">
              ${d.description || 'Storewide promotional discount'}
            </td>
            <td style="padding: 0.85rem 1rem; white-space: nowrap;">
              <button 
                type="button" 
                class="stylux-toggle-discount-btn" 
                data-index="${index}" 
                data-code="${d.code}"
                style="
                  padding: 4px 10px;
                  border-radius: 9999px;
                  font-size: 0.75rem;
                  font-weight: 600;
                  cursor: pointer;
                  border: 1px solid ${isActive ? '#bbf7d0' : '#fecaca'};
                  background: ${isActive ? '#dcfce7' : '#fee2e2'};
                  color: ${isActive ? '#15803d' : '#b91c1c'};
                  transition: all 0.2s;
                "
                title="Click to toggle status"
              >
                ${isActive ? '● Active' : '✕ Inactive'}
              </button>
            </td>
            <td style="padding: 0.85rem 1rem; white-space: nowrap;">
              <button 
                type="button" 
                class="stylux-delete-discount-btn" 
                data-index="${index}" 
                data-code="${d.code}"
                style="padding: 4px 10px; font-size: 0.75rem; font-weight: 600; background: #fff1f2; color: #e11d48; border: 1px solid #fecdd3; border-radius: 4px; cursor: pointer; transition: opacity 0.2s;"
                onmouseover="this.style.opacity='0.8'"
                onmouseout="this.style.opacity='1'"
              >
                Delete
              </button>
            </td>
          </tr>
        `;
      }).join('');
    }

    // 2. Mobile Cards
    if (mobileContainer) {
      mobileContainer.innerHTML = discounts.map((d, index) => {
        const isPercent = d.type === 'percentage';
        const formattedValue = isPercent ? `${d.value}% Off` : `Rs.${Number(d.value).toLocaleString()} Off`;
        const isActive = d.active !== false;

        return `
          <div class="stylux-mobile-card">
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-bottom: 8px;">
              <div style="display: flex; align-items: center; gap: 8px;">
                <span class="stylux-m-promo-code">${d.code}</span>
                <span style="font-weight: 700; color: #059669; font-size: 0.8125rem;">${formattedValue}</span>
              </div>
              <button 
                type="button" 
                class="stylux-toggle-discount-btn" 
                data-index="${index}" 
                data-code="${d.code}"
                style="
                  padding: 4px 10px;
                  border-radius: 9999px;
                  font-size: 0.75rem;
                  font-weight: 600;
                  cursor: pointer;
                  border: 1px solid ${isActive ? '#bbf7d0' : '#fecaca'};
                  background: ${isActive ? '#dcfce7' : '#fee2e2'};
                  color: ${isActive ? '#15803d' : '#b91c1c'};
                  transition: all 0.2s;
                  min-height: 28px;
                "
                title="Click to toggle status"
              >
                ${isActive ? '● Active' : '✕ Inactive'}
              </button>
            </div>

            <div style="display: flex; align-items: center; justify-content: space-between; gap: 8px; padding-top: 8px; border-top: 1px solid #f1f5f9;">
              <div style="color: #64748b; font-size: 0.75rem; line-height: 1.3;">
                ${d.description || (isPercent ? 'Percentage Promo Discount' : 'Flat PKR Savings')}
              </div>
              <button 
                type="button" 
                class="stylux-delete-discount-btn" 
                data-index="${index}" 
                data-code="${d.code}"
                style="padding: 4px 10px; font-size: 0.75rem; font-weight: 600; background: #fff1f2; color: #e11d48; border: 1px solid #fecdd3; border-radius: 6px; cursor: pointer; transition: opacity 0.2s; white-space: nowrap;"
              >
                Delete
              </button>
            </div>
          </div>
        `;
      }).join('');
    }

    // Bind Toggle Active Status across both desktop and mobile
    document.querySelectorAll('.stylux-toggle-discount-btn').forEach(btn => {
      btn.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const code = (btn.dataset.code || '').trim().toUpperCase();
        const list = getDiscounts();
        const item = list.find(d => (d.code || '').trim().toUpperCase() === code);
        if (item) {
          item.active = !item.active;
          saveDiscounts(list);
          showToast(`Promo code "${code}" is now ${item.active ? 'Active' : 'Inactive'}`, 'success');
          renderDiscountsTable();
        }
      };
    });

    // Bind Delete Promo Code across both desktop and mobile
    document.querySelectorAll('.stylux-delete-discount-btn').forEach(btn => {
      btn.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const code = (btn.dataset.code || '').trim().toUpperCase();
        if (!code) return;
        if (confirm(`Are you sure you want to delete promo code "${code}"?`)) {
          let list = getDiscounts();
          list = list.filter(d => (d.code || '').trim().toUpperCase() !== code);
          saveDiscounts(list);
          // Also clear from cart if currently applied
          try {
            const applied = localStorage.getItem('thudarum_applied_coupon');
            if (applied && JSON.parse(applied).code.toUpperCase() === code) {
              localStorage.removeItem('thudarum_applied_coupon');
            }
          } catch (err) {}
          showToast(`Promo code "${code}" deleted`, 'info');
          renderDiscountsTable();
        }
      };
    });
  }

  function openNewDiscountModal() {
    const modal = document.getElementById('stylux-admin-new-discount-modal');
    if (modal) {
      modal.style.display = 'flex';
      const input = document.getElementById('admin-new-discount-code');
      if (input) {
        input.value = '';
        setTimeout(() => input.focus(), 60);
      }
    }
  }

  function closeNewDiscountModal() {
    const modal = document.getElementById('stylux-admin-new-discount-modal');
    if (modal) modal.style.display = 'none';
  }

  function setupNewDiscountModalEvents() {
    const openBtn = document.getElementById('admin-open-create-discount-btn');
    if (openBtn) openBtn.onclick = openNewDiscountModal;

    const closeBtn = document.getElementById('admin-close-discount-modal-btn');
    if (closeBtn) closeBtn.onclick = closeNewDiscountModal;

    const cancelBtn = document.getElementById('admin-cancel-discount-modal-btn');
    if (cancelBtn) cancelBtn.onclick = closeNewDiscountModal;

    const typeSelect = document.getElementById('admin-new-discount-type');
    const valLabel = document.getElementById('admin-new-discount-val-label');
    const valInput = document.getElementById('admin-new-discount-value');
    if (typeSelect && valLabel && valInput) {
      typeSelect.onchange = () => {
        if (typeSelect.value === 'percentage') {
          valLabel.textContent = 'Value (% Off)';
          valInput.placeholder = 'e.g. 10';
          valInput.max = '100';
        } else {
          valLabel.textContent = 'Value (Flat PKR Off)';
          valInput.placeholder = 'e.g. 500';
          valInput.removeAttribute('max');
        }
      };
    }

    const form = document.getElementById('stylux-admin-new-discount-form');
    if (form) {
      form.onsubmit = (e) => {
        e.preventDefault();
        const code = (document.getElementById('admin-new-discount-code')?.value || '').trim().toUpperCase();
        if (!code) {
          showToast('Please enter a promo code string', 'error');
          return;
        }

        const type = document.getElementById('admin-new-discount-type')?.value || 'percentage';
        const value = Math.max(1, parseFloat(document.getElementById('admin-new-discount-value')?.value) || 10);
        const description = (document.getElementById('admin-new-discount-desc')?.value || '').trim();
        const active = Boolean(document.getElementById('admin-new-discount-active')?.checked);

        const list = getDiscounts();
        const existingIdx = list.findIndex(d => d.code.toUpperCase() === code);
        const newDiscount = {
          code: code,
          type: type,
          value: value,
          description: description || (type === 'percentage' ? `${value}% Promotional Discount` : `Rs.${value} Off Promo`),
          active: active
        };

        if (existingIdx > -1) {
          list[existingIdx] = newDiscount;
        } else {
          list.push(newDiscount);
        }

        saveDiscounts(list);
        closeNewDiscountModal();
        form.reset();
        showToast(`Promo code "${code}" saved successfully!`, 'success');
        renderDiscountsTable();
      };
    }
  }

  // --- 5B. HOMEPAGE HERO SLIDER SLIDES MANAGER ---
  const HERO_SLIDES_STORAGE_KEY = 'stylux_hero_slides';

  function getHeroSlides() {
    if (window.StyluxSharedStore && typeof window.StyluxSharedStore.getHeroSlides === 'function') {
      return window.StyluxSharedStore.getHeroSlides();
    }
    try {
      const raw = localStorage.getItem('stylux_shared_hero_slides') || localStorage.getItem(HERO_SLIDES_STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length > 0) return parsed;
      }
    } catch (e) {
      console.warn('[StyluxAdmin] Error reading hero slides:', e);
    }
    return (window.__STYLUX_SHARED_CONFIG__ && window.__STYLUX_SHARED_CONFIG__.heroSlides) || [];
  }

  function saveHeroSlides(slides) {
    if (window.StyluxSharedStore && typeof window.StyluxSharedStore.setHeroSlides === 'function') {
      window.StyluxSharedStore.setHeroSlides(slides);
    } else {
      try {
        localStorage.setItem('stylux_shared_hero_slides', JSON.stringify(slides));
        localStorage.setItem(HERO_SLIDES_STORAGE_KEY, JSON.stringify(slides));
        window.dispatchEvent(new CustomEvent('stylux:hero_slides_updated', { detail: { slides } }));
      } catch (e) {
        console.error('[StyluxAdmin] Failed to save hero slides:', e);
      }
    }
  }

  function resetHeroSlidesToDefault() {
    if (window.StyluxSharedStore && typeof window.StyluxSharedStore.resetHeroSlides === 'function') {
      window.StyluxSharedStore.resetHeroSlides();
    } else {
      try {
        localStorage.removeItem('stylux_shared_hero_slides');
        localStorage.removeItem(HERO_SLIDES_STORAGE_KEY);
        window.dispatchEvent(new CustomEvent('stylux:hero_slides_updated', { detail: { reset: true } }));
      } catch (e) {
        console.error('[StyluxAdmin] Failed to reset hero slides:', e);
      }
    }
    showToast('Hero section reset to default luxury banner', 'info');
    renderHeroSlidesManager();
  }

  function renderHeroSlidesManager() {
    const tableBody = document.getElementById('admin-hero-slides-table-body');
    const mobileContainer = document.getElementById('admin-hero-slides-mobile-container');
    if (!tableBody && !mobileContainer) return;

    const slides = getHeroSlides();

    if (slides.length === 0) {
      const emptyHtmlDesktop = `
        <tr>
          <td colspan="6" style="text-align: center; padding: 3rem 1.5rem; background: #ffffff;">
            <div style="width: 48px; height: 48px; border-radius: 50%; background: #eff6ff; border: 1px solid #bfdbfe; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 0.75rem; color: #2563eb;">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
            </div>
            <div style="font-weight: 700; color: #0f172a; font-size: 0.9375rem; margin-bottom: 4px;">Default Luxury Video Active</div>
            <div style="color: #64748b; font-size: 0.8125rem; max-width: 480px; margin: 0 auto 1.25rem; line-height: 1.5;">
              Currently the storefront hero presents the default cinematic video. Upload 1 image to replace it with a high-resolution banner, or upload 2+ images to automatically rotate them every 5 seconds.
            </div>
            <button type="button" class="stylux-pill-btn admin-empty-create-slide-trigger" style="background: #0f172a; color: #ffffff; border-color: #0f172a; padding: 0.55rem 1.25rem; border-radius: 6px; font-size: 0.8125rem; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px;">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              + Upload First Hero Image
            </button>
          </td>
        </tr>
      `;

      const emptyHtmlMobile = `
        <div style="text-align: center; padding: 2.25rem 1.25rem; background: #ffffff; border-radius: 12px; border: 1px solid #e2e8f0; margin-top: 0.5rem;">
          <div style="width: 44px; height: 44px; border-radius: 50%; background: #eff6ff; border: 1px solid #bfdbfe; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 0.75rem; color: #2563eb;">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
          </div>
          <div style="font-weight: 700; color: #0f172a; font-size: 0.9375rem; margin-bottom: 4px;">Default Luxury Video Active</div>
          <div style="color: #64748b; font-size: 0.8125rem; margin-bottom: 1.25rem; line-height: 1.4;">
            Upload images to replace the hero video. 2+ images will automatically rotate every 5 seconds.
          </div>
          <button type="button" class="stylux-pill-btn admin-empty-create-slide-trigger" style="background: #0f172a; color: #ffffff; border-color: #0f172a; padding: 0.65rem 1.25rem; border-radius: 8px; font-size: 0.8125rem; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; width: 100%; justify-content: center;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            + Add Hero Image Slide
          </button>
        </div>
      `;

      if (tableBody) tableBody.innerHTML = emptyHtmlDesktop;
      if (mobileContainer) mobileContainer.innerHTML = emptyHtmlMobile;

      document.querySelectorAll('.admin-empty-create-slide-trigger').forEach(b => {
        b.onclick = openNewSlideModal;
      });
      return;
    }

    // Render Desktop Table
    if (tableBody) {
      tableBody.innerHTML = slides.map((slide, idx) => {
        const rotationText = slides.length > 1 ? '● Auto-slides (5s)' : '● Static Banner (1 image)';
        const rotationColor = slides.length > 1 ? '#059669' : '#2563eb';
        const rotationBg = slides.length > 1 ? '#dcfce7' : '#eff6ff';
        const rotationBorder = slides.length > 1 ? '#bbf7d0' : '#bfdbfe';
        const slideDevice = (slide.device || 'all').toLowerCase();

        return `
          <tr style="border-bottom: 1px solid #f1f5f9; background: #ffffff;">
            <td style="padding: 0.75rem 1rem;">
              <div style="width: 90px; height: 50px; border-radius: 6px; overflow: hidden; background: #0f172a; border: 1px solid #cbd5e1; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
                <img src="${slide.url}" alt="${slide.title || 'Slide'}" style="width: 100%; height: 100%; object-fit: cover;" onerror="this.src='https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=300'" />
              </div>
            </td>
            <td style="padding: 0.75rem 1rem;">
              <div style="font-weight: 600; color: #0f172a; font-size: 0.875rem;">${slide.title || `Hero Slide #${idx + 1}`}</div>
              <div style="font-size: 0.75rem; color: #94a3b8; margin-top: 2px; text-overflow: ellipsis; overflow: hidden; max-width: 320px; white-space: nowrap;">${slide.url}</div>
            </td>
            <td style="padding: 0.75rem 1rem;">
              <span style="font-size: 0.8125rem; font-weight: 700; color: #0f172a; background: #f1f5f9; padding: 3px 8px; border-radius: 4px; border: 1px solid #e2e8f0;">
                Position #${idx + 1} of ${slides.length}
              </span>
            </td>
            <td style="padding: 0.75rem 1rem; white-space: nowrap;">
              <select 
                class="stylux-slide-device-select" 
                data-index="${idx}" 
                style="padding: 4px 8px; font-size: 0.75rem; font-weight: 600; border: 1px solid #cbd5e1; border-radius: 6px; background: #ffffff; color: #0f172a; cursor: pointer; outline: none; transition: border-color 0.2s;"
              >
                <option value="all" ${slideDevice === 'all' ? 'selected' : ''}>🌐 Both (Mobile & Desktop)</option>
                <option value="desktop" ${slideDevice === 'desktop' ? 'selected' : ''}>🖥️ Desktop Only</option>
                <option value="mobile" ${slideDevice === 'mobile' ? 'selected' : ''}>📱 Mobile Only</option>
              </select>
            </td>
            <td style="padding: 0.75rem 1rem; white-space: nowrap;">
              <span style="display: inline-block; padding: 4px 10px; border-radius: 9999px; font-size: 0.75rem; font-weight: 600; background: ${rotationBg}; color: ${rotationColor}; border: 1px solid ${rotationBorder};">
                ${rotationText}
              </span>
            </td>
            <td style="padding: 0.75rem 1rem; white-space: nowrap;">
              <button 
                type="button" 
                class="stylux-delete-slide-btn" 
                data-index="${idx}" 
                data-id="${slide.id || idx}"
                style="padding: 4px 10px; font-size: 0.75rem; font-weight: 600; background: #fff1f2; color: #e11d48; border: 1px solid #fecdd3; border-radius: 4px; cursor: pointer; transition: opacity 0.2s;"
                onmouseover="this.style.opacity='0.8'"
                onmouseout="this.style.opacity='1'"
              >
                Delete
              </button>
            </td>
          </tr>
        `;
      }).join('');
    }

    // Render Mobile Cards
    if (mobileContainer) {
      mobileContainer.innerHTML = slides.map((slide, idx) => {
        const rotationText = slides.length > 1 ? '5s Auto Rotation' : 'Single Banner';
        const rotationColor = slides.length > 1 ? '#059669' : '#2563eb';
        const rotationBg = slides.length > 1 ? '#dcfce7' : '#eff6ff';
        const slideDevice = (slide.device || 'all').toLowerCase();

        return `
          <div class="stylux-mobile-card" style="background: #ffffff; border: 1px solid #e2e8f0; border-radius: 10px; padding: 0.85rem; margin-bottom: 0.65rem;">
            <div style="display: flex; gap: 10px; align-items: center; margin-bottom: 8px;">
              <div style="width: 72px; height: 46px; border-radius: 6px; overflow: hidden; background: #0f172a; flex-shrink: 0; border: 1px solid #cbd5e1;">
                <img src="${slide.url}" alt="${slide.title || 'Slide'}" style="width: 100%; height: 100%; object-fit: cover;" onerror="this.src='https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=300'" />
              </div>
              <div style="flex: 1; min-width: 0;">
                <div style="font-weight: 700; color: #0f172a; font-size: 0.8125rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                  ${slide.title || `Hero Slide #${idx + 1}`}
                </div>
                <div style="display: flex; align-items: center; gap: 6px; margin-top: 3px; flex-wrap: wrap;">
                  <span style="font-size: 0.6875rem; color: #64748b; font-weight: 600;">Position ${idx + 1}/${slides.length}</span>
                  <span style="font-size: 0.6875rem; background: ${rotationBg}; color: ${rotationColor}; padding: 1px 6px; border-radius: 4px; font-weight: 600;">${rotationText}</span>
                </div>
              </div>
            </div>

            <!-- Device Selector for Mobile View -->
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-bottom: 8px; padding: 6px 8px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px;">
              <span style="font-size: 0.75rem; color: #475569; font-weight: 600;">Target Device:</span>
              <select 
                class="stylux-slide-device-select-mobile" 
                data-index="${idx}" 
                style="padding: 3px 6px; font-size: 0.75rem; font-weight: 600; border: 1px solid #cbd5e1; border-radius: 4px; background: #ffffff; color: #0f172a; cursor: pointer; outline: none;"
              >
                <option value="all" ${slideDevice === 'all' ? 'selected' : ''}>🌐 Both (All)</option>
                <option value="desktop" ${slideDevice === 'desktop' ? 'selected' : ''}>🖥️ Desktop Only</option>
                <option value="mobile" ${slideDevice === 'mobile' ? 'selected' : ''}>📱 Mobile Only</option>
              </select>
            </div>

            <div style="display: flex; align-items: center; justify-content: flex-end; gap: 8px; padding-top: 6px; border-top: 1px solid #f1f5f9;">
              <button 
                type="button" 
                class="stylux-delete-slide-btn" 
                data-index="${idx}" 
                data-id="${slide.id || idx}"
                style="padding: 4px 12px; font-size: 0.75rem; font-weight: 600; background: #fff1f2; color: #e11d48; border: 1px solid #fecdd3; border-radius: 6px; cursor: pointer;"
              >
                Delete Slide
              </button>
            </div>
          </div>
        `;
      }).join('');
    }

    // Bind Device Selection Changes across desktop and mobile
    document.querySelectorAll('.stylux-slide-device-select, .stylux-slide-device-select-mobile').forEach(sel => {
      sel.onchange = (e) => {
        const idx = parseInt(sel.dataset.index, 10);
        if (isNaN(idx)) return;
        const newDevice = sel.value || 'all';
        const list = getHeroSlides();
        if (idx >= 0 && idx < list.length) {
          list[idx].device = newDevice;
          saveHeroSlides(list);
          const devLabel = newDevice === 'desktop' ? 'Desktop Only' : newDevice === 'mobile' ? 'Mobile Only' : 'Both (Mobile & Desktop)';
          showToast(`Hero slide #${idx + 1} display set to: ${devLabel}`, 'success');
          renderHeroSlidesManager();
        }
      };
    });

    // Bind Delete Slide across desktop and mobile
    document.querySelectorAll('.stylux-delete-slide-btn').forEach(btn => {
      btn.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const idx = parseInt(btn.dataset.index, 10);
        if (isNaN(idx)) return;

        if (confirm('Delete this image slide from the hero banner?')) {
          let list = getHeroSlides();
          if (idx >= 0 && idx < list.length) {
            list.splice(idx, 1);
            saveHeroSlides(list);
            showToast('Hero slide removed', 'info');
            renderHeroSlidesManager();
          }
        }
      };
    });
  }

  function openNewSlideModal() {
    const modal = document.getElementById('stylux-admin-new-slide-modal');
    if (!modal) return;
    modal.style.display = 'flex';

    // Reset preview
    const previewContainer = document.getElementById('admin-slide-preview-container');
    const previewImg = document.getElementById('admin-slide-preview-img');
    const urlInput = document.getElementById('admin-new-slide-url');
    const fileInput = document.getElementById('admin-slide-file-input');
    const titleInput = document.getElementById('admin-new-slide-title');
    const deviceInput = document.getElementById('admin-new-slide-device');

    if (previewContainer) previewContainer.style.display = 'none';
    if (previewImg) previewImg.src = '';
    if (urlInput) urlInput.value = '';
    if (fileInput) fileInput.value = '';
    if (titleInput) titleInput.value = '';
    if (deviceInput) deviceInput.value = 'all';
  }

  function closeNewSlideModal() {
    const modal = document.getElementById('stylux-admin-new-slide-modal');
    if (modal) modal.style.display = 'none';
  }

  function setupNewSlideModalEvents() {
    const openBtn = document.getElementById('admin-open-create-slide-btn');
    if (openBtn) openBtn.onclick = openNewSlideModal;

    const closeBtn = document.getElementById('admin-close-slide-modal-btn');
    if (closeBtn) closeBtn.onclick = closeNewSlideModal;

    const cancelBtn = document.getElementById('admin-cancel-slide-modal-btn');
    if (cancelBtn) cancelBtn.onclick = closeNewSlideModal;

    const dropzone = document.getElementById('admin-slide-dropzone');
    const fileInput = document.getElementById('admin-slide-file-input');
    const urlInput = document.getElementById('admin-new-slide-url');
    const previewContainer = document.getElementById('admin-slide-preview-container');
    const previewImg = document.getElementById('admin-slide-preview-img');

    let uploadedBase64 = '';

    if (dropzone && fileInput) {
      dropzone.onclick = () => fileInput.click();

      dropzone.ondragover = (e) => {
        e.preventDefault();
        dropzone.style.borderColor = '#2563eb';
        dropzone.style.background = '#eff6ff';
      };

      dropzone.ondragleave = (e) => {
        e.preventDefault();
        dropzone.style.borderColor = '#cbd5e1';
        dropzone.style.background = '#f8fafc';
      };

      dropzone.ondrop = (e) => {
        e.preventDefault();
        dropzone.style.borderColor = '#cbd5e1';
        dropzone.style.background = '#f8fafc';
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
          handleFile(e.dataTransfer.files[0]);
        }
      };

      fileInput.onchange = (e) => {
        if (e.target.files && e.target.files[0]) {
          handleFile(e.target.files[0]);
        }
      };
    }

    function handleFile(file) {
      if (!file.type.startsWith('image/')) {
        showToast('Please select a valid image file', 'error');
        return;
      }
      const reader = new FileReader();
      reader.onload = (loadEvt) => {
        uploadedBase64 = loadEvt.target.result;
        if (previewContainer && previewImg) {
          previewImg.src = uploadedBase64;
          previewContainer.style.display = 'block';
        }
        if (urlInput) urlInput.value = '';
      };
      reader.readAsDataURL(file);
    }

    if (urlInput) {
      urlInput.oninput = () => {
        const val = urlInput.value.trim();
        if (val) {
          uploadedBase64 = '';
          if (previewContainer && previewImg) {
            previewImg.src = val;
            previewContainer.style.display = 'block';
          }
        } else if (!uploadedBase64) {
          if (previewContainer) previewContainer.style.display = 'none';
        }
      };
    }

    const form = document.getElementById('stylux-admin-new-slide-form');
    if (form) {
      form.onsubmit = (e) => {
        e.preventDefault();
        const urlVal = (urlInput ? urlInput.value : '').trim();
        const finalImageSrc = uploadedBase64 || urlVal;

        if (!finalImageSrc) {
          showToast('Please either upload an image file or provide an image URL', 'error');
          return;
        }

        const titleVal = (document.getElementById('admin-new-slide-title')?.value || '').trim();
        const deviceVal = document.getElementById('admin-new-slide-device')?.value || 'all';
        const slides = getHeroSlides();
        const newSlide = {
          id: 'slide_' + Date.now(),
          url: finalImageSrc,
          title: titleVal || `Hero Slide ${slides.length + 1}`,
          device: deviceVal,
          createdAt: Date.now(),
          active: true
        };

        slides.push(newSlide);
        saveHeroSlides(slides);
        closeNewSlideModal();
        form.reset();
        uploadedBase64 = '';
        if (previewContainer) previewContainer.style.display = 'none';

        showToast(`Hero slide added! Total slides: ${slides.length} (${slides.length > 1 ? '5-second auto rotation active' : 'single hero image'})`, 'success');
        renderHeroSlidesManager();
      };
    }
  }

  // --- 6. LUXURY TOAST NOTIFICATIONS ---
  function showToast(message, type = 'info') {
    const container = document.getElementById('stylux-admin-toast-container');
    if (!container) return;

    const toast = document.createElement('div');
    toast.style.cssText = `
      display: flex;
      align-items: center;
      gap: 10px;
      background: #ffffff;
      color: #0f172a;
      padding: 11px 18px;
      border-radius: 8px;
      font-size: 0.8125rem;
      font-weight: 500;
      border: 1px solid #e2e8f0;
      border-left: 4px solid ${type === 'success' ? '#10b981' : type === 'error' ? '#ef4444' : '#d97706'};
      box-shadow: 0 10px 25px -5px rgba(0,0,0,0.12);
      animation: styluxToastIn 0.3s ease-out;
      margin-top: 8px;
    `;

    toast.innerHTML = `
      <span style="font-weight: 700; color: ${type === 'success' ? '#10b981' : type === 'error' ? '#ef4444' : '#d97706'};">${type === 'success' ? '✓' : type === 'error' ? '✕' : 'ℹ'}</span>
      <span>${message}</span>
    `;

    container.appendChild(toast);
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transition = 'opacity 0.3s';
      setTimeout(() => toast.remove(), 300);
    }, 2800);
  }

  // --- 7. INITIALIZATION & GLOBAL LISTENERS ---
  function init() {
    getInventory();
    syncFrontEndInventory();
    setupNewOrderModalEvents();
    setupNewDiscountModalEvents();
    setupNewSlideModalEvents();
    syncWithShopifyCatalog();

    function handleHash() {
      if (window.location.hash === '#admin-dashboard') {
        openDashboard();
      }
    }
    window.addEventListener('hashchange', handleHash);
    if (window.location.hash === '#admin-dashboard') {
      setTimeout(handleHash, 400);
    }

    document.querySelectorAll('#header-admin-link, [data-admin-navlink="true"]').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openDashboard();
      });
    });

    window.addEventListener('stylux:order_status_updated', () => {
      if (isDashboardOpen) renderDashboardUI();
    });

    window.addEventListener('stylux:discounts_updated', () => {
      if (isDashboardOpen) renderDiscountsTable();
    });

    window.addEventListener('stylux:hero_slides_updated', () => {
      if (isDashboardOpen) renderHeroSlidesManager();
    });

    window.addEventListener('stylux:auth_changed', () => {
      if (!checkAdminAccess() && isDashboardOpen) {
        closeDashboard();
      }
    });

    setTimeout(syncFrontEndInventory, 600);
    setTimeout(syncFrontEndInventory, 1500);

    // Firebase "Save & Sync All" Button
    var syncBtn = document.getElementById('admin-firebase-sync-btn');
    if (syncBtn) {
      syncBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        firebaseSyncAll();
      });
    }
  }

  // --- 8. FIREBASE "SAVE & SYNC ALL" ---
  function firebaseSyncAll() {
    var syncBtn = document.getElementById('admin-firebase-sync-btn');
    var originalHTML = syncBtn ? syncBtn.innerHTML : '';

    // Show syncing state
    if (syncBtn) {
      syncBtn.disabled = true;
      syncBtn.style.opacity = '0.75';
      syncBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation: spin 1s linear infinite;"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg> <span>Syncing...</span>';
    }

    // Add spin animation if not already present
    if (!document.getElementById('stylux-sync-spin-style')) {
      var style = document.createElement('style');
      style.id = 'stylux-sync-spin-style';
      style.textContent = '@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }';
      document.head.appendChild(style);
    }

    var successCount = 0;
    var errorCount = 0;
    var totalOps = 2;
    var completed = 0;

    function checkDone() {
      completed++;
      if (completed >= totalOps) {
        setTimeout(function() {
          if (syncBtn) {
            syncBtn.disabled = false;
            syncBtn.style.opacity = '1';
            if (errorCount === 0) {
              syncBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> <span>Synced!</span>';
              syncBtn.style.background = '#059669';
              showToast('All data synced to Firebase — live across all browsers & devices!', 'success');
            } else {
              syncBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg> <span>Sync Failed</span>';
              syncBtn.style.background = '#dc2626';
              showToast('Firebase sync failed — check console & database rules', 'error');
            }

            // Reset button after 2.5 seconds
            setTimeout(function() {
              syncBtn.innerHTML = originalHTML;
              syncBtn.style.background = '#059669';
            }, 2500);
          }
        }, 400);
      }
    }

    // 1. Push Discounts to Firebase
    try {
      var currentDiscounts = getDiscounts();
      if (window.StyluxSharedStore && typeof window.StyluxSharedStore.setDiscounts === 'function') {
        window.StyluxSharedStore.setDiscounts(currentDiscounts);
      }
      // Also direct Firebase push as fallback
      if (typeof window.firebase !== 'undefined' && window.firebase.database) {
        var db = window.firebase.database();
        db.ref('stylux/discounts').set(currentDiscounts)
          .then(function() { successCount++; checkDone(); })
          .catch(function(err) { console.error('[StyluxSync] Discounts push error:', err); errorCount++; checkDone(); });
      } else {
        errorCount++;
        checkDone();
      }
    } catch(e) {
      console.error('[StyluxSync] Discounts error:', e);
      errorCount++;
      checkDone();
    }

    // 2. Push Hero Slides to Firebase
    try {
      var currentSlides = getHeroSlides();
      if (window.StyluxSharedStore && typeof window.StyluxSharedStore.setHeroSlides === 'function') {
        window.StyluxSharedStore.setHeroSlides(currentSlides);
      }
      // Also direct Firebase push as fallback
      if (typeof window.firebase !== 'undefined' && window.firebase.database) {
        var db2 = window.firebase.database();
        db2.ref('stylux/hero_slides').set(currentSlides)
          .then(function() { successCount++; checkDone(); })
          .catch(function(err) { console.error('[StyluxSync] Hero slides push error:', err); errorCount++; checkDone(); });
      } else {
        errorCount++;
        checkDone();
      }
    } catch(e) {
      console.error('[StyluxSync] Hero slides error:', e);
      errorCount++;
      checkDone();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose Global StyluxAdmin API
  window.StyluxAdmin = {
    open: openDashboard,
    close: closeDashboard,
    isOpen: () => isDashboardOpen,
    getInventory,
    updateStock,
    updatePrice,
    resetInventoryToDefault,
    getMetrics,
    syncFrontEndInventory,
    syncWithShopifyCatalog,
    renderDashboardUI,
    renderOrdersTable,
    renderInventoryTable,
    renderDiscountsTable,
    getDiscounts,
    saveDiscounts,
    openNewOrderModal,
    closeNewOrderModal,
    openNewDiscountModal,
    closeNewDiscountModal,
    getHeroSlides,
    saveHeroSlides,
    resetHeroSlidesToDefault,
    renderHeroSlidesManager,
    openNewSlideModal,
    closeNewSlideModal,
    showToast,
    firebaseSyncAll
  };

})();
